import React from 'react';
import { Flex, Text, Tag } from 'core/components';

const JourneysCopilotSuggestions = ({ suggestions, onSuggestionClick, activeChatContext }) => {
  // Group suggestions from activeChatContext by type, preserving context objects
  const contextSuggestionsByType = {};
  const contextsByType = {};
  if (activeChatContext) {
    Array.from(activeChatContext).forEach((context) => {
      if (context.suggestions && context.type) {
        if (!contextSuggestionsByType[context.type]) {
          contextSuggestionsByType[context.type] = [];
          contextsByType[context.type] = context; // Store the context object for display name
        }
        contextSuggestionsByType[context.type].push(...context.suggestions);
      }
    });
  }

  // Filter out context suggestions from the main suggestions array
  const contextSuggestionsFlat = Object.values(contextSuggestionsByType).flat();
  const generalSuggestions = suggestions.filter((suggestion) => !contextSuggestionsFlat.includes(suggestion));

  // Shared props for suggestion tags
  const tagProps = {
    interactive: true,
    // intent: 'primary',
    // round: true,
    minimal: true,
    alignText: 'left',
    p: '4px 8px',
    large: true,
    style: { alignSelf: 'flex-start' }
  };

  const renderSuggestionTag = (suggestion) => (
    <Tag {...tagProps} icon="send-message" key={suggestion} onClick={() => onSuggestionClick(suggestion)}>
      {suggestion}
    </Tag>
  );

  const showGeneralSuggestions = Array.from(activeChatContext)?.length === 0;

  return (
    <Flex flexDirection="column" gap="8px" p={2} height="100%" justifyContent="flex-end">
      {/* General suggestions */}
      {showGeneralSuggestions && generalSuggestions.length > 0 && (
        <>
          <Text small fontWeight="medium" mb="4px">
            Suggestions
          </Text>
          {generalSuggestions.map(renderSuggestionTag)}
        </>
      )}

      {/* Context-based suggestions grouped by type */}
      {Object.entries(contextSuggestionsByType).map(([type, typeSuggestions]) => (
        <React.Fragment key={type}>{typeSuggestions.map(renderSuggestionTag)}</React.Fragment>
      ))}

      <Text small muted textAlign="center" mt={3}>
        Even AI has off days. Please verify important information.
      </Text>
    </Flex>
  );
};

export default JourneysCopilotSuggestions;
